import React, { useEffect } from "react";
import Webabout from "./Webabout";
import Websolution from "./Websolution";
import Webfeatures from "./Webfeatures";
import Webcards from "./Webcards";
import Webbanner from "./Webbanner";

const Webdev = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div>
        <Webbanner/>
      <Webabout/>
      <Websolution />

      <Webfeatures/>
      <Webcards/>
    </div>
  );
};

export default Webdev;
